import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ProductItem } from './ProductItem';
import { motion } from 'framer-motion';
import { Sprite } from './Sprite';
import { observable } from 'mobx';
import { integration } from '../integration';
import { B64Image } from './B64Image';

const Dimmer = styled.div`
	flex: 1 1 100px;
	position:relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100vw;
	height: 100%;
	box-sizing: border-box;
	padding-top: ${p => p.modal ? '17vw' : 0};
	background: ${p => p.modal ? 'rgba(0,0,0,0.5)' : 'none'};
	overflow: hidden;
	pointer-events: auto;
`

const Wrap = styled.div`
	flex: 100vh;
	width: 100vw;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	max-height: 90vh;
	transform: scale(0.99);
	@media (min-aspect-ratio: 9/15){
		transform: scale(0.8);
	}
`

const Header = styled(motion.div)`
	position: absolute;
	top: 0;
	width: 100%;
	text-align: center;
	z-index: 100;
	& > img {
		width: 100%;
	}
	@media (min-aspect-ratio: 9/15){
		top: -12vw;
	}
`

const Body = styled(motion.div)`
	flex: 0 0 auto;
	overflow: visible;
	text-align: center;
	color: black;
	position: relative;
	&::-webkit-scrollbar { width: 0 !important }
	flex-direction: column;
	display: flex;
	width: 100%;
	padding-top: 12.5vw;
	box-sizing: border-box;
	max-height: 90vh;
	@media (min-aspect-ratio: 9/15){
		padding-top: 0;
	}
`

const Content = styled.div`
	background-image: url('/assets/productStore/panel_02.png');
	background-size: 100% 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0 0.5vw;
	align-items: center;
	/* & > * {
		flex: 0 0 auto;
	} */
`

const Scroller = styled.div`
	margin: 0 auto;
	overflow: auto;
	position: relative;
	padding-bottom: 10px;
	height: 100%;
	width: 100%;
	-webkit-overflow-scrolling: touch;
	overflow: scroll;

`

const CloseButton = styled.img`
	width: 12vw !important;
	position: absolute;
	top: -3vw;
	right: 9vw;
	z-index: 1000;
`

@observer
export class ProductStore extends Component {

	@observable dataReady = true;

	constructor(props){
		super(props);

		var watchVideoExists = false;

		store.products.forEach(element => {
			if(element.productId === 'WATCH_H1'){
				watchVideoExists = true;
			} else {
				var s = element.productId.split("_H");
				element.heartNumberString = s.length > 0 ? s[1] : '';
				if(element.heartNumberString !== '') {
					var num = Number(element.heartNumberString);
					num = Math.floor(num * 0.8);
					element.heartNumberDiscountedString = num.toString();
				} else {
					element.heartNumberDiscountedString = '';
				}
			}
		});
		if(!watchVideoExists) {
			var product = {productId:"WATCH_H1",title:"A Handful", description:"of Bonus Hearts!", price:"$4.99"};
			store.products.push(product);
		}

		integration.postAnalyticsEvent(`store_menu_open`, `economy`);

	}

	prevent(e){
		e.stopPropagation();
		// e.preventDefault();
	}

	close = () => {
		window.manager.playAudio("poopPop");
		store.showProductStore = false;
		integration.postAnalyticsEvent(`store_exit`, `economy`);
	}

	render(){
		console.log(`shakeproduct render: ${store.products.length}`)
		var a = {scale: 1, transition:{delay: 1}};
		return (
			<Dimmer
				onClick={this.prevent}
				onMouseDown={this.prevent}
				onMouseUp={this.prevent}
				onTouchStart={this.prevent}
				onPointerUp={this.prevent}
				onPointerDown={this.prevent}
				modal={this.props.modal}
				style={{pointerEvents: 'initial'}}
			>
				<Wrap>
					<Header
					initial={{scale: 0}}
					animate={a}
					modal={this.props.modal}
					>
						{this.props.modal && <CloseButton src="/assets/btn_close.png" onClick={() => this.close()}/>}
						<Sprite w={100} unit="%" localize sprite="store_banner_header.png"/>
					</Header>
					<Body
					initial={{y: '100vh'}}
					animate={{
						y: 0,
						transition: {delay: 0.5}
					}}>
						<B64Image alt="" style={{width: '100%'}} src="/assets/productStore/panel_01.png"/>
						<Content>
							<Sprite w={100} unit="%" localize sprite="store_banner_01_globalLaunch.png"/>
							<Sprite w={80} unit="%" localize sprite="store_text_removeAds.png"/>
							<Scroller>
								<div>
									{store.products.map((p, i) => {
										console.log(`shake product ID: ${p.productId}`)
										return <ProductItem key={p.productId} i={i}/>
									})}
								</div>
							</Scroller>
						</Content>
						{this.props.modal && <img alt="" style={{width: '100%', height: '7.656vw'}} src="/assets/productStore/panel_03.png"/>}
					</Body>
				</Wrap>
			</Dimmer>
		);
	}
}
